module.exports = __webpack_public_path__ + "h5/img/freeback.abc4bfe7.png";